import { HomeHeroSlider } from '../../../../defaultTheme/js/src/__utils/sliders';

function videoFrame () {
	jQuery('.videolink').click(function(e) {
		e.preventDefault();
		jQuery('.videomodal').addClass('open');
	});

	jQuery('.videomodal .close').click(function(e) {
		e.preventDefault();
		jQuery(".youtubevideo")[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
		jQuery('.videomodal').removeClass('open');
	});
}

// GLOBAL APP CONTROLLER
const controller = {
    init() {
		HomeHeroSlider.init();
    },
    loaded() {
		videoFrame();
	},
    resized() {},
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
